import { render, staticRenderFns } from "./DetallePagos.vue?vue&type=template&id=fbfa57ea&scoped=true&"
import script from "./DetallePagos.vue?vue&type=script&lang=js&"
export * from "./DetallePagos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfa57ea",
  null
  
)

export default component.exports